import { useCallback, useEffect, useState } from 'react';
import UserManagementService from '../../../services/UserManagement.service';
import useQuery from '../../../util/useQuery';
import useNotify from '../../../context/Notification/useNotify';
import { useTranslation } from 'react-i18next';

export const useEmailSetting = () => {
    const [emailList, setEmailList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageValue, setPageValue] = useState({
        p: 1,
        ps: 10,
        total: 0,
    });

    const getEmailSettings = useCallback(async () => {
        setLoading(true);
        try {
            const { data } = await UserManagementService.getEmailSettings({
                p: pageValue.p,
                ps: pageValue.ps,
            });
            if (data.resultData) {
                setEmailList(data.resultData.result);
                setLoading(false);
                setPageValue({
                    p: data.resultData.page,
                    ps: data.resultData.pageSize,
                    total: data.resultData.total,
                });
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    }, [pageValue]);

    useEffect(() => {
        getEmailSettings();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        loading,
        emailList,
        pageValue,
        setPageValue,
        getEmailSettings,
    };
};

export const useEmailSettingDetail = () => {
    const [emailDetail, setEmailDetail] = useState({});
    const [loading, setLoading] = useState(false);
    const params = useQuery();

    const getEmailSettingDetail = useCallback(async () => {
        const id = params?.get('id');
        setLoading(true);
        try {
            const { data } = await UserManagementService.getEmailDeatils(id);
            if (data.resultData) {
                setEmailDetail(data.resultData);
                setLoading(false);
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    }, [params]);

    useEffect(() => {
        getEmailSettingDetail();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params]);

    return {
        loading,
        emailDetail,
        getEmailSettingDetail,
    };
};

export const useEmailSettingUpdate = () => {
    const [loading, setLoading] = useState(false);
    const notify = useNotify();
    const { t } = useTranslation();

    const updateEmailSetting = useCallback(async (payload, action) => {
        setLoading(true);
        try {
            const { data } = await UserManagementService.updateEmailSetting(
                payload
            );
            if (data.resultCode === 1) {
                setLoading(false);
                notify({
                    title: t('common.Success'),
                    description: t('common.SaveData'),
                });
                action();
            } else {
                setLoading(false);
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        loading,
        updateEmailSetting,
    };
};
